import { hideModal } from 'ducks/modal';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ConfirmationModal from './ConfirmationModal';
import EditTheoryLessonEntryModal from './EditTheoryLessonEntryModal';
import EditDrivingLessonEntryModal from './EditDrivingLessonEntryModal';
import SelectUndoneEntryModal from './SelectUndoneEntryModal';
import LoginModal from './LoginModal';
import MessageModal from './MessageModal';
import DriverCardModal from './DriverCardModal';

const MODAL_COMPONENTS = {
  'CONFIRM': ConfirmationModal,
  'LOGIN': LoginModal,
  'MESSAGE': MessageModal,
  'EDIT_THEORYLESSON_ENTRY': EditTheoryLessonEntryModal,
  'EDIT_DRIVINGLESSON_ENTRY': EditDrivingLessonEntryModal,
  'COMPLETE_UNDONE_ENTRY': EditTheoryLessonEntryModal,
  'SELECT_UNDONE_ENTRY': SelectUndoneEntryModal,
  'DRIVER_CARD_ENTRY': DriverCardModal,
};

const RootModal = ({modalType, modalProps, hideModal}) => {
  if (!modalType) {
    return null;
  }

  const SpecificModal = MODAL_COMPONENTS[modalType];
  return <SpecificModal hideModal={hideModal} {...modalProps} modalType={modalType} />;
};

const mapDispatchToProps = dispatch => bindActionCreators({
  hideModal: () => hideModal(),
}, dispatch);

export default connect(
  state => state.modal,
  mapDispatchToProps
)(RootModal);


// WEBPACK FOOTER //
// ./src/components/modal/RootModal.jsx